import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const JURISDICTION_DETAILS_EVENT_NAMES = {
  JURISDICTION_DETAILS_ACTION: 'jurisdiction_details_action',
  SHAPE_FILE_VERIFIED: 'shape_file_verified',
  SEEK_CLARIFICATION: 'seek_clarification',
};

export const trackJurisdictionDetailsAction = (action, irpVersion) => {
  gspx.trackEvent({
    name: JURISDICTION_DETAILS_EVENT_NAMES.JURISDICTION_DETAILS_ACTION,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin JurisdictionDetails',
      legacy_name: action,
      Category: 'Issue',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackShapeFileVerified = (name, irpVersion) => {
  gspx.trackEvent({
    name: JURISDICTION_DETAILS_EVENT_NAMES.SHAPE_FILE_VERIFIED,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin JurisdictionDetails',
      legacy_name: name,
      Category: 'Issue',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackSeekClarification = (name, irpVersion) => {
  gspx.trackEvent({
    name: JURISDICTION_DETAILS_EVENT_NAMES.SEEK_CLARIFICATION,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin JurisdictionDetails',
      legacy_name: name,
      Category: 'Issue',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};
